export default __webpack_public_path__ + "6dbfd9c.png";